import React, { useState } from "react";
import { Pagination } from "@mui/material";
import { limit } from "utils";

export const PaginationFillTable = ({
  count,
  handleReturn,
  page,
  listLength,
  hideGoTo,
}) => {
  const [selectedPage, setSelectedPage] = useState(1);
  const limitCountNumber = limit;
  const pages = listLength ? Math.ceil(count / limitCountNumber) : 0;
  const pagesList = Array.from({ length: pages }, (_, i) => i + 1);
  const firsCountNumber = page ? (page - 1) * limitCountNumber + 1 : 1;
  const lastCount = page
    ? page * limitCountNumber > count
      ? count
      : page * limitCountNumber
    : 1;

  return (
    <div className={"pagination-wrapper"}>
      <div>
        <p className={"pagination-full-show-context"}>
          {`${firsCountNumber} - ${lastCount} of ${count}`}
        </p>
      </div>

      <div className="flex-all-center" style={{ gap: 40 }}>
        <Pagination
          onChange={(event, val) => handleReturn(val)}
          page={page}
          count={count && Math.ceil(count / limitCountNumber)}
          color={"primary"}
        />

        {!hideGoTo && (
          <div className="flex-all-center" style={{ gap: 14 }}>
            <button
              className="reset-btn"
              onClick={() => {
                handleReturn(selectedPage);
                setSelectedPage(selectedPage);
              }}
            >
              <p className="pagination-full-show-context"> Go to page</p>
            </button>
            <div className={"pagination-full-select-page-box"}>
              <select
                defaultValue={page}
                value={selectedPage}
                onChange={(e) => setSelectedPage(+e.target.value)}
              >
                {pagesList?.map((i, j) => (
                  <option key={j} value={i}>
                    {i}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
